// eslint-disable-next-line no-undef
module.exports = em = (px) => `${Math.round((px / 16) * 10000) / 10000}em`
